import React, { useState } from "react";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

import Tooltip from "Components/Common/Tooltip";
import { DocumentName } from "Components/RegisterBuildingForm/FireProtection/style";
import DocumentPreviewModal from "Components/Common/DocumentPreviewModal";
import Collapse from "./Collapse";

import { getImageUrl } from "utils";
import getFileExtension from "utils/getFileExtension";
import removeExtension from "utils/removeExtension";

import pdfImg from "assets/images/pdf.png";

const docFormats = ["doc", "docx"];

const FireSafetyDocumentView = ({
  causeAndEffectMatrixDocumentUrl,
  dbrDocuments,
  isExpandable = true,
}) => {
  const [documentToPreview, setDocumentToPreview] = useState();

  const previewButtonHandler = (name, documentURL) => {
    const fileExtension = getFileExtension(name ?? "");
    const url = getImageUrl(documentURL ?? "");

    if (docFormats.includes(fileExtension?.toLowerCase())) {
      toast.success("Document downloaded successfully");
    } else {
      setDocumentToPreview({
        documentTypeName: "",
        url,
        documentType: fileExtension,
        documentName: removeExtension(name ?? ""),
      });
    }
  };

  return (
    <>
      {!!documentToPreview && (
        <DocumentPreviewModal
          isOpen
          handleClose={() => setDocumentToPreview(null)}
          {...documentToPreview}
        />
      )}

      {/* cause and effect matrix document*/}
      {!!causeAndEffectMatrixDocumentUrl && (
        <Collapse
          title="Cause And Effect Matrix Document"
          isExpandable={isExpandable}
        >
          <Row className="d-flex gap-3 flex-wrap">
            <Col lg={2} md={4} sm={6} xs={12} className="image-container">
              <a
                onClick={() =>
                  previewButtonHandler(
                    causeAndEffectMatrixDocumentUrl,
                    causeAndEffectMatrixDocumentUrl
                  )
                }
              >
                <Box
                  component="img"
                  className="image d-block m-auto cursor-pointer"
                  alt="document image"
                  src={
                    getFileExtension(
                      (causeAndEffectMatrixDocumentUrl ?? "").toLowerCase()
                    ) === "pdf"
                      ? pdfImg
                      : getImageUrl(causeAndEffectMatrixDocumentUrl)
                  }
                />
              </a>
            </Col>
          </Row>
        </Collapse>
      )}

      {/* DBR documents */}
      {!!dbrDocuments?.length && (
        <Collapse title="DBR Documents" isExpandable={isExpandable}>
          <Row className="d-flex gap-3 flex-wrap">
            {dbrDocuments.map(({ url, name }, index) => (
              <div className="image-container" key={index}>
                <a onClick={() => previewButtonHandler(name, url)}>
                  <Box
                    component="img"
                    className="image d-block m-auto cursor-pointer"
                    alt="document image"
                    src={
                      getFileExtension((url ? url : name)?.toLowerCase()) ===
                      "pdf"
                        ? pdfImg
                        : getImageUrl(url)
                    }
                  />
                </a>
                <Tooltip title={name}>
                  <DocumentName fontSize={13} variant="body2">
                    {name}
                  </DocumentName>
                </Tooltip>
              </div>
            ))}
          </Row>
        </Collapse>
      )}
    </>
  );
};

FireSafetyDocumentView.propTypes = {
  dbrDocuments: PropTypes.array,
  isExpandable: PropTypes.bool,
  causeAndEffectMatrixDocumentUrl: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation()(FireSafetyDocumentView);
